var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{staticClass:"k-button k-button-icontext filter-clear",attrs:{"role":"button","href":"#"},on:{"click":_vm.buttonClick}},[_c('span',{staticClass:"k-icon k-i-plus"}),_vm._v("\n    Use in store\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }